import { AppIcons } from "../../../data/appIcons";
import Image from "../../image/Image";
import "./SidebarModel.scss";

const SidebarModel = ({ children, ...props }) => {
  return (
    <div className={`sidebar-model ${props.isOpen ? "active-model" : ""}`}>
      <div className="right-model-section">
        <div className={`model-content ${props.contentClass}`}>
          <div className="model-header">
            <div className="model-title">{props.modalTitle}</div>
            <div
              className="close-btn"
              onClick={props.onClose ? props.onClose : null}
            >
              <Image imagePath={AppIcons.closeIcon} altText="Close" />
            </div>
          </div>
          <div className="model-body">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default SidebarModel;
